import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Collapse } from "react-bootstrap";
import { find } from "lodash";

import HeaderWrapper from "../common/HeaderWrapper";
import ContractTierList from "./ContractTierList";
import * as contractTierActions from "../../actions/contractTierActions";
import * as modalActions from "../../actions/modalActions";
import ContractTierForm from "./ContractTierForm";
import Modal from "../common/Modal";

const ContractTierPage = ({ contractTiers, actions, contractTier, codes }) => {
  const [fetched, setFetched] = useState(false);
  const [formOpened, setFormOpened] = useState(false);
  const [state, setState] = useState({});

  const onClickAdd = () => {
    setFormOpened((prev) => !prev);
    setState({});
  };

  const onClickEdit = (id) => {
    actions.getContractTier(id, true);
    const tier = find(contractTiers, { id });
    setState(tier);
  };

  useEffect(() => {
    if (!fetched) {
      actions.loadContractTiers();
      setFetched(true);
    }
  }, [actions, fetched]);

  const handleAdd = async (values) => {
    setFormOpened(false);
    await actions.createContractTier(values);
    actions.loadContractTiers();
  };

  const handleEdit = async (values) => {
    await actions.updateContractTier(values);
    actions.loadContractTiers();
  };

  const addContractTierForm = (
    <ContractTierForm
      adding
      codes={codes}
      contractTier={state}
      onCancel={() => setFormOpened(false)}
      onSave={handleAdd}
    />
  );

  const editContractTierForm = (
    <ContractTierForm
      codes={codes}
      contractTier={contractTier}
      onCancel={() => actions.hideModal("contractTierModal")}
      onSave={handleEdit}
    />
  );

  return (
    <React.Fragment>
      <HeaderWrapper
        breadcrumbs={[{ label: "Settings" }, { label: "Contract Tiers" }]}
        onClickAdd={onClickAdd}
      />
      <div>
        <Collapse in={formOpened}>
          <div>
            <div className="content-wrapper">
              <h4>Add Contract Tier</h4>
              {addContractTierForm}
            </div>
          </div>
        </Collapse>
      </div>
      <div className="content-wrapper">
        <ContractTierList
          contractTiers={contractTiers}
          onClickEdit={onClickEdit}
        />
        <Modal
          id="contractTierModal"
          title="Contract Tier"
          body={editContractTierForm}
          close={() => actions.hideModal("contractTierModal")}
        />
      </div>
    </React.Fragment>
  );
};

ContractTierPage.propTypes = {
  actions: PropTypes.object,
  contractTiers: PropTypes.array.isRequired,
  contractTier: PropTypes.object,
  codes: PropTypes.array
};

function mapStatesToProps(state) {
  return {
    contractTiers: state.reducers.contractTiers,
    contractTier: state.reducers.contractTier,
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...contractTierActions, ...modalActions },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ContractTierPage);
